import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import BottomToTop from '../../../../../../components/transitions/bottom-to-top'
import { BlackMask } from '../../../../../../components/mask'
import { Iconfont } from '../../../../../../components/icon/iconfont'
import { FormattedMessage } from 'react-intl'
import PayMethodList from '../../../checkout/fragments/payment-methods'

export const PaymentMethods = props => {
    useStyles(classes)
    const { payMethods, orderTotal, onClose, selectPayMethodHandle, selectedPayMethod, klarnas, inputOrder, selectedCard, onError } = props

    return <div className={classes.PaymentMethods}>
        <div className={classes.Hd}>
            <span className={classes.Title}>
                <FormattedMessage id="eidt_payment_method" defaultMessage="Edit Payment Method" />
            </span>
            <Iconfont className={classes.Close} onClick={onClose}>&#xe7c9;</Iconfont>
        </div>
        <div className={classes.Dsc}>
            <FormattedMessage id="please_select_method_to_pay" defaultMessage="Please select the payment method to complete the payment" />
        </div>
        <div className={classes.Bd}>
            <PayMethodList
                klarnas={klarnas}
                className={classes.PaymentMethods}
                orderTotal={orderTotal}
                selectPayMethodHandle={selectPayMethodHandle}
                selectedPayMethod={selectedPayMethod}
                payMethodList={payMethods}
                ignoreViewMore
                inputOrder={inputOrder}
                selectedCard={selectedCard}
                onError={onError}
                />
        </div>
    </div>
}


export default props => {
    useStyles(classes)
    return <React.Fragment>
        <BottomToTop in={props.show} className={classes.PaymentMethodsContainer}>
            <div>
                <PaymentMethods {...props} />
            </div>
        </BottomToTop>
        {props.show && <BlackMask onClick={props.onClose} />}
    </React.Fragment>
}